import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FOCUS_VIEW, MerchantReportTypeValue } from 'Common/enums';
import { shouldShowMerchants } from 'Selectors';

import clsx from 'clsx';
import TransactionVolumeDashlet from '../TransactionVolumeDashlet';
import TransactionValueDashlet from '../TransactionValueDashlet';
import TopFiveMerchantDashlet from '../TopFiveMerchantByPercentAcceptRejectDashlet';
import { useGetTop5VolumeMinColumns, useGetTop5ValueMinColumns } from './utils';
import HeaderRows from './components/HeaderRows';

import styles from './MerchantSummaryReportView.css';

type Props = {
    formValues?: ProcessedNewMerchantReportFormValues;
    createdReportInfo?: CreatedReportInfo;
    newlyGenerated?: boolean;
    users?: UsersHashmap;
};

const MerchantSummaryReportView = ({ formValues, createdReportInfo, newlyGenerated, users }: Props) => {
    const { t } = useTranslation();
    const [focusView, setFocusView] = useState<string>(FOCUS_VIEW.ACCEPT);
    const dashletsRowCN = clsx(styles.flexRow, styles.chartsRow);
    const top5ValueMinCols = useGetTop5ValueMinColumns();
    const top5VolumneMinCols = useGetTop5VolumeMinColumns();

    const renderDashlets = () => {
        if (formValues?.reportType === MerchantReportTypeValue.singleMerchant || !shouldShowMerchants()) return null;
        return (
            <div className={dashletsRowCN}>
                <TopFiveMerchantDashlet
                    focusView={focusView as AcceptRejectReview}
                    formValues={formValues}
                    className={styles.top5VolumeDashletContainer}
                    minColumns={top5VolumneMinCols}
                    chartType='volume'
                />
                <TopFiveMerchantDashlet
                    focusView={focusView as AcceptRejectReview}
                    formValues={formValues}
                    className={styles.top5ValueDashletContainer}
                    minColumns={top5ValueMinCols}
                    chartType='value'
                />
            </div>
        );
    };

    return (
        <div className={styles.reportViewContainer}>
            {formValues ? (
                <>
                    {formValues && (
                        <HeaderRows
                            newlyGenerated={newlyGenerated}
                            formValues={formValues}
                            focusView={focusView as AcceptRejectReview}
                            setFocusView={setFocusView}
                            createdReportInfo={createdReportInfo}
                            users={users}
                        />
                    )}
                    <div className={dashletsRowCN}>
                        <TransactionVolumeDashlet focusView={focusView} formValues={formValues} />
                        <TransactionValueDashlet focusView={focusView} formValues={formValues} />
                    </div>
                    {renderDashlets()}
                </>
            ) : (
                <>
                    <div>
                        {shouldShowMerchants()
                            ? t('newMerchantReportInstructions')
                            : t('Select a date range to generate a new report.')}
                    </div>
                    <div className={styles.newReportInstructions}>{t('newMerchantReportInstructionsPt2')}</div>
                </>
            )}
        </div>
    );
};

export default MerchantSummaryReportView;
